import { render, staticRenderFns } from "./forgotPasStepTwo.vue?vue&type=template&id=6f035ec8&"
import script from "./forgotPasStepTwo.vue?vue&type=script&lang=js&"
export * from "./forgotPasStepTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports